import { ref } from 'vue';
import { filterListToOptions, sequence } from '@/ui/helpers/uiHelper';
import { useTask } from '@/ui/concerns';
import { filter as getAllEntityItems } from '@/services/api/resources/entityItem';
import { SelectOptions } from '@/ui/types';

export function useFilters() {
  const entityItems = ref([] as SelectOptions);

  const getFilters = useTask(
    () => sequence(
      getAllEntityItems(),
    ),
    ([
      entityItemList,
    ]) => {
      entityItems.value = filterListToOptions(entityItemList);
    },
  );

  return {
    getFilters,
    entityItems,
  };
}
